import { render, staticRenderFns } from "./ClientStatus.vue?vue&type=template&id=03f16ee3"
import script from "./ClientStatus.vue?vue&type=script&lang=js"
export * from "./ClientStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports